import { render, staticRenderFns } from "./AuctionActiveDate.vue?vue&type=template&id=8afe5528&scoped=true"
import script from "./AuctionActiveDate.vue?vue&type=script&lang=js"
export * from "./AuctionActiveDate.vue?vue&type=script&lang=js"
import style0 from "./AuctionActiveDate.vue?vue&type=style&index=0&id=8afe5528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afe5528",
  null
  
)

export default component.exports